const rangeSlider = document.getElementById('range_id');
const tooltipOne = document.getElementById('tooltip_one');
const serviceNowDiv = document.getElementById('cost_of_servisenow');
const spaceWarp = document.getElementById('cost_of_spacewarp');
const movingTooltip = document.getElementById('moving_tooltip');
const discount = document.getElementById('discount');

function getTheColor(colorVal) {
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
	let dbSize = 0;
	dbSize = colorVal;
	let costOfServicenow = 0;
	let amount = 0;
	let diff = 0;
	let discountper = 0;
	if (dbSize !== '') {
		if (dbSize <= 4) {
			serviceNowDiv.innerHTML = 0;
			spaceWarp.innerHTML = 0;
		}
		if (dbSize > 4) {
			costOfServicenow = (parseInt(dbSize, 10) - 4) * 17000;
			amount = costOfServicenow - (parseInt(dbSize, 10) - 4) * 1500;
			diff = costOfServicenow - amount;
			discountper = ((costOfServicenow - diff) / costOfServicenow) * 100;
		}
	}
	return {
		cost: formatter.format(costOfServicenow),
		amountSpc: formatter.format(amount),
		diff: formatter.format(diff),
		discountper,
	};
}

function loadSlider() {
	const currentVal = 5;
	const calVal = getTheColor(currentVal);
	const { cost, diff } = calVal;
	const isMobile = /Android|iPhone/i.test(navigator.userAgent);
	let moveDiv = 0;
	if (isMobile) {
		moveDiv = parseInt(currentVal - 26, 0) + 55;
	} else {
		moveDiv = parseInt(currentVal - 26, 0) * 7.5;
	}
	const moveDivString = moveDiv.toString();
	movingTooltip.setAttribute('style', `position:relative; left:${moveDivString}px`);
	tooltipOne.textContent = `${currentVal} TB`;
	serviceNowDiv.textContent = cost;
	spaceWarp.textContent = diff;
}

if (spaceWarp) {
	loadSlider();
}
if (rangeSlider) {
	rangeSlider.oninput = () => {
		const currentVal = rangeSlider.value;
		const calVal = getTheColor(currentVal);
		const { cost, diff, discountper } = calVal;
		const isMobile = /Android|iPhone/i.test(navigator.userAgent);
		let moveDiv = 0;
		if (isMobile) {
			moveDiv = parseInt(currentVal - 26, 0) + 55;
		} else {
			moveDiv = parseInt(currentVal - 26, 0) * 7.5;
		}
		const moveDivString = moveDiv.toString();
		movingTooltip.setAttribute('style', `position:relative; left:${moveDivString}px`);
		tooltipOne.textContent = `${currentVal} TB`;
		serviceNowDiv.textContent = cost;
		spaceWarp.textContent = diff;
		const Save = 'Save ';
		const percentage = '%*';
		discount.textContent = Save + parseFloat(discountper).toFixed(2) + percentage;
	};
}
